"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignatureNode = void 0;
const sanitize_html_1 = __importDefault(require("sanitize-html"));
const types_1 = require("./types");
const scrubHtml = (html) => sanitize_html_1.default(html, { allowedTags: [], allowedAttributes: {} });
const renderSignature = (config) => {
    const { signerNum, label } = config.attributes;
    return `
    <div class="signature-name">
      <div class="signature-line">
        ${scrubHtml(`[sig|req|signer${signerNum}]`)}
      </div>
      <div class="signature-label">
        ${label}
      </div>
    </div>
    <div class="signature-date">
      <div class="signature-line">
        ${scrubHtml(`[date|req|signer${signerNum}]`)}
      </div>
      <div class="signature-label">
        Date
      </div>
    </div>`;
};
// Since the tags are white, rendering a text node and previewing it are essentially identical.
const SignatureNode = (config) => ({
    id: config.id,
    version: 1,
    type: types_1.NodeTypes.SignatureNode,
    render: () => renderSignature(config),
    preview: () => renderSignature(config),
});
exports.SignatureNode = SignatureNode;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2lnbmF0dXJlTm9kZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWIvbm9kZXMvc2lnbmF0dXJlTm9kZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxrRUFBeUM7QUFFekMsbUNBQXlEO0FBRXpELE1BQU0sU0FBUyxHQUFHLENBQUMsSUFBYSxFQUFFLEVBQUUsQ0FBQyx1QkFBWSxDQUFDLElBQUksRUFBRSxFQUFFLFdBQVcsRUFBRSxFQUFFLEVBQUUsaUJBQWlCLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztBQUNwRyxNQUFNLGVBQWUsR0FBRyxDQUFDLE1BQXVCLEVBQUUsRUFBRTtJQUNsRCxNQUFNLEVBQUUsU0FBUyxFQUFFLEtBQUssRUFBRSxHQUFHLE1BQU0sQ0FBQyxVQUFVLENBQUM7SUFDL0MsT0FBTzs7O1VBR0MsU0FBUyxDQUFDLGtCQUFrQixTQUFTLEdBQUcsQ0FBQzs7O1VBR3pDLEtBQUs7Ozs7O1VBS0wsU0FBUyxDQUFDLG1CQUFtQixTQUFTLEdBQUcsQ0FBQzs7Ozs7V0FLekMsQ0FBQztBQUNWLENBQUMsQ0FBQztBQUVGLCtGQUErRjtBQUMxRixNQUFNLGFBQWEsR0FBRyxDQUFDLE1BQXVCLEVBQXFCLEVBQUUsQ0FBQyxDQUFDO0lBQzVFLEVBQUUsRUFBRSxNQUFNLENBQUMsRUFBRTtJQUNiLE9BQU8sRUFBRSxDQUFDO0lBQ1YsSUFBSSxFQUFFLGlCQUFTLENBQUMsYUFBYTtJQUM3QixNQUFNLEVBQUUsR0FBRyxFQUFFLENBQUMsZUFBZSxDQUFDLE1BQU0sQ0FBQztJQUNyQyxPQUFPLEVBQUUsR0FBRyxFQUFFLENBQUMsZUFBZSxDQUFDLE1BQU0sQ0FBQztDQUN2QyxDQUFDLENBQUM7QUFOVSxRQUFBLGFBQWEsaUJBTXZCIn0=